import { Permission } from "api";
import { createAsyncAction, createAction } from "typesafe-actions";
import annotationsConstants from "./annotations.constants";
import { Annotation, AnnotationAction, AttachedAsset } from "./interfaces";
import { AssetType } from "api/assets";
const {
    FETCH_ANNOTATIONS_REQUEST,
    FETCH_ANNOTATIONS_SUCCESS,
    FETCH_ANNOTATIONS_FAILED,

    SUBMIT_ANNOTATIONS_REQUEST,
    SUBMIT_ANNOTATIONS_SUCCESS,
    SUBMIT_ANNOTATIONS_FAILED,

    SUBMIT_IS_ANNOTATION_REVIEWED_REQUEST,
    SUBMIT_IS_ANNOTATION_REVIEWED_SUCCESS,
    SUBMIT_IS_ANNOTATION_REVIEWED_FAILED,

    REMOVE_ANNOTATION_REQUEST,
    REMOVE_ANNOTATION_SUCCESS,
    REMOVE_ANNOTATION_FAILED,

    ATTACH_ASSET_REQUEST,
    ATTACH_ASSET_SUCCESS,
    ATTACH_ASSET_FAILED,

    REMOVE_ASSET_REQUEST,
    REMOVE_ASSET_SUCCESS,
    REMOVE_ASSET_FAILED,

    SET_SELECTED_ANNOTATION,
    RESET_ANNOTATION_STATE,
    ADD_ANNOTATION,
    UPDATE_ANNOTATIONS,
} = annotationsConstants;

export const fetchAnnotations = createAsyncAction(
    FETCH_ANNOTATIONS_REQUEST,
    FETCH_ANNOTATIONS_SUCCESS,
    FETCH_ANNOTATIONS_FAILED
)<
    { matSpecId: number; adMaterialId: number; assetId?: number },
    { adMaterialId: number; annotations: Annotation[]; permissions: Permission[] },
    ErrorHandler
>();

export const submitAnnotations = createAsyncAction(
    SUBMIT_ANNOTATIONS_REQUEST,
    SUBMIT_ANNOTATIONS_SUCCESS,
    SUBMIT_ANNOTATIONS_FAILED
)<
    {
        materialSpecId: number;
        adMaterialId: number;
        annotations: Annotation[];
        action: AnnotationAction;
        assetId?: number;
    },
    { annotations: Annotation[]; permissions: Permission[] },
    ErrorHandler
>();

export const submitIsAnnotationReviewed = createAsyncAction(
    SUBMIT_IS_ANNOTATION_REVIEWED_REQUEST,
    SUBMIT_IS_ANNOTATION_REVIEWED_SUCCESS,
    SUBMIT_IS_ANNOTATION_REVIEWED_FAILED
)<{ id: number; reviewed: boolean }, null, ErrorHandler>();

export const removeAnnotation = createAsyncAction(
    REMOVE_ANNOTATION_REQUEST,
    REMOVE_ANNOTATION_SUCCESS,
    REMOVE_ANNOTATION_FAILED
)<{ annotationId: number }, null, ErrorHandler>();

export const attachAssetToAnnotation = createAsyncAction(
    ATTACH_ASSET_REQUEST,
    ATTACH_ASSET_SUCCESS,
    ATTACH_ASSET_FAILED
)<
    // using selectionId as newly added annotations won't have id
    { materialSpecificationId: number; adMaterialId: number; selectionId: number; asset: File; assetType: AssetType },
    AttachedAsset & { selectionId: number },
    ErrorHandler
>();

export const removeAnnotationAsset = createAsyncAction(REMOVE_ASSET_REQUEST, REMOVE_ASSET_SUCCESS, REMOVE_ASSET_FAILED)<
    // using selectionId as newly added annotations won't have id
    { assetId: number; selectionId: number },
    { selectionId: number },
    ErrorHandler
>();

export const setSelectedAnnotation = createAction(SET_SELECTED_ANNOTATION)<Annotation>();

export const resetAnnotationsState = createAction(RESET_ANNOTATION_STATE)<void>();

export const addAnnotation = createAction(ADD_ANNOTATION)<{ annotation: Annotation }>();

export const updateAnnotations = createAction(UPDATE_ANNOTATIONS)<{ theAnnotations: Annotation[] }>();
